//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { storeValue, getValue, removeItem } from '@helpers/localStorage';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
import {
  VerifiedStripeKey,
  SkipStripe,
  StripeStatus,
  ReferralKey,
  AfterWelcomeModalLastDisplayed,
  AfterWelcomeModalLastDisplayedDontShowAgain,
  QRAccountStatusTrueModalShown,
} from '@helpers/constants/localStorage';
//------------------------------------------------------------------------------
// Exports ---------------------------------------------------------------------
export const isRegistered = (user) => user && user.isRegistered && user.data;

export const skipStripe = () => {
  return getValue(SkipStripe, true);
};

export const verifiedStripe = () => {
  return getValue(VerifiedStripeKey);
};

export const isStripeActive = () => {
  const sStatus = getValue(StripeStatus);
  if (sStatus === 'active') {
    return true;
  } else {
    return false;
  }
};

export const isSkipStripe = () => {
  return getValue(SkipStripe) && !verifiedStripe();
};

export const updateStripeVerification = (verified) => {
  if (verified) {
    storeValue(VerifiedStripeKey, true);
  } else {
    removeItem(VerifiedStripeKey);
  }
};

export const checkReferralAndAuthorize = () => {
  const referral = getValue(ReferralKey);
};

export const completedRegistration = (user) => {
  return user && isRegistered(user) && (verifiedStripe() || skipStripe());
};

export const handleAfterWelcomeModalHelper = ({ remindMeLater, dontShowAgain }) => {
  const now = Date.now();

  // TODO user preferences feature work
  if (remindMeLater) {
    storeValue(AfterWelcomeModalLastDisplayed, now);
  }

  if (dontShowAgain) {
    storeValue(AfterWelcomeModalLastDisplayedDontShowAgain, true); // this uses a boolean to decide if to show modal
  }

  return `AfterWelcome modal last displayed at: ${now}, ${new Date(now)}`;
};

export const handleAfterWelcomeQuickRecoAccTrueModalHelper = ({ hasQRAccountResponse }) => {
  
  if (hasQRAccountResponse) {
    storeValue(QRAccountStatusTrueModalShown, true);
  }
}
